// ======================================================================
// File Name       : ModalAction
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import { MODAL_OPEN_MODAL, MODAL_HIDE_MODAL } from '../constants/actionTypes/modal';
import { HIDE_MESSAGE } from '../constants/actionTypes/message';
import store from '../store';

export function openModal(modalId) {
  return {
    type: MODAL_OPEN_MODAL,
    modalId,
  };
}

export function hideModal() {
  store.dispatch({
    type: HIDE_MESSAGE,
  });
  return {
    type: MODAL_HIDE_MODAL,
  };
}
